<template>
  <article class="file-preview">
    <p class="file-preview__title">Your file:</p>
    <div class="file-preview__area">
      <preloader :loading="loading" />
      <Media :file="file" v-if="!loading" />
    </div>
    <footer class="file-preview__actions" v-if="file">
      <a
        class="file-preview__action-btn"
        target="_blank"
        v-bind:href="file.isSupportedFile ? file.url : '#'"
        v-bind:class="{ 'file-preview__action-btn--disabled': !file.isSupportedFile }"
      >
        <icon-open class="ico" />
        Open
      </a>
      <a
        class="file-preview__action-btn"
        ref="downloadBtn"
        v-on:click="download($event)"
        v-bind:href="allowDownload ? file.blob : '#'"
        v-bind:download="allowDownload ? file.title : false"
      >
        <icon-load class="ico" />
        Download
      </a>
    </footer>
  </article>
</template>

<script>
  import { File } from '../services/FileService';
  import Media from './Media';
  import Preloader from './Preloader.vue';
  import IconLoad from './content-icons/icon-load.vue';
  import IconOpen from './content-icons/icon-open.vue';
  import ConfirmModal from './ConfirmModal';

  export default {
    name: 'FilePreview',
    components: {
      Media,
      IconLoad,
      IconOpen,
      Preloader
    },
    data: function() {
      return {
        file: null,
        loading: true,
        allowDownload: false
      };
    },
    async created() {
      this.file = await File.getFromAWS(this.$route.params.hs);
      this.loading = false;
      this.allowDownload = this.file.isTypeCorrespondsToExtension;
    },
    methods: {
      showModal() {
        this.$modal.show(
          ConfirmModal,
          {
            title: 'Are you sure want to download?',
            content: ` The declared type of file doesn't match with its original one. Continue downloading only if you're absolutely
        sure in the file safety.`,
            btnCloseText: 'Cancel',
            btnConfirmText: 'Continue',
            handleConfirm: this.startDownload
          },
          {
            height: 'auto',
            maxWidth: 641,
            adaptive: true,
            clickToClose: false,
            classes: 'vue-modal'
          }
        );
      },
      download(ev) {
        if (!this.allowDownload) {
          ev.preventDefault();
          this.showModal();
        }
      },

      startDownload() {
        this.allowDownload = true;
        this.$nextTick(() => {
          this.$refs.downloadBtn.click();
          this.allowDownload = false;
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  @import 'src/scss/variables';

  .file-preview {
    max-width: 756px;
    width: 100%;
    margin-top: auto;
    margin-bottom: auto;

    &__title {
      font-size: 2.8rem;
      font-weight: bold;
      margin-bottom: 0.6em;
    }

    &__area {
      width: 100%;
      min-height: 398px;
      border-radius: 17px;
      background-color: rgba(255, 255, 255, 0.79);
      background-image: url("data:image/svg+xml;utf8,<svg width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><rect rx='17' ry='17' width='100%' height='100%' style='fill: none; stroke-opacity: 0.3;stroke: black; stroke-width: 1; stroke-dasharray: 8'/></svg>");
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    &__actions {
      margin-top: 40px;
      text-align: center;
    }

    &__action-btn {
      font-size: 1.8rem;
      font-weight: 600;
      color: $blue;
      position: relative;
      display: inline-flex;
      align-items: center;

      .ico {
        margin-right: 0.7em;
        color: currentColor;
        opacity: 0.5;
      }

      &:not(:last-child) {
        margin-right: 55px;
      }
    }

    &__action-btn--disabled {
      color: $gray;
      cursor: text;
      pointer-events: none;
    }
  }
</style>
